// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Include-recipient-na{width:276px;height:19px;font-family:GothamSSm;font-size:16px;font-weight:500;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:var(--greyish-brown)}\n", ""]);
// Exports
module.exports = exports;
